import React, { useState } from "react";
import { RefreshCw } from "lucide-react";

interface ErrorRetryProps {
  onRetry?: () => void;
}

export default function ErrorRetry({ onRetry }: ErrorRetryProps) {
  return (
    // <div className="mb-8 bg-gradient-to-br from-red-50 to-orange-50 border border-red-200 rounded p-8 shadow-lg animate-in slide-in-from-top-4 duration-300">
    <div className="p-8">
      <div className="text-center">
        <div className="flex items-center justify-center w-full">
          <img
            src="/images/conection_error.png"
            className="w-52 md:w-[18rem] h-auto object-cover"
          />
        </div>

        <div className="max-w-md mx-auto mt-4">
          <h3 className="text-base md:text-lg font-bold text-red-700 mb-2">
            Không thể kết nối tới máy chủ
          </h3>
          <p className="text-black mb-6 text-xs md:text-sm leading-relaxed">
            Vui lòng kiểm tra mạng và thử lại.
          </p>
          {onRetry && (
            <div className="space-y-4">
              <button
                onClick={onRetry}
                className="inline-flex items-center px-6 py-2 bg-red-600 text-white text-sm md:text-base font-medium rounded-xl hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 shadow-md hover:shadow-lg"
              >
                <>
                  <RefreshCw className="w-4 h-4 mr-2" />
                  <span className="text-sm md:text-base">Thử lại</span>
                </>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
